import React from 'react';
import './Locatie.css';
import { useLanguage } from './LanguageContext';

function Locatie() {
  const { t } = useLanguage();

  return (
    <div 
      className="locatie-page" 
      style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7)), url("/images/campuri.jpeg")' }}
    >
      
      {/* HERO SECTION */}
      <div className="locatie-hero">
        <h1>{t('locatie_title')}</h1>
        <p>{t('locatie_subtitle')}</p>
      </div>

      {/* Container conținut */}
      <div className="locatie-container">
        
        {/* Secțiunea Atracții */}
        <div className="attractions-panel">
          <h2>{t('locatie_attractions_title')}</h2>
          
          <div className="cards-grid">
            
            {/* Card 1 */}
            <div className="attraction-card">
              <img src="/images/turn.jpg" alt={t('locatie_card1_title')} />
              <div className="card-content">
                <h3>{t('locatie_card1_title')}</h3>
                <p>{t('locatie_card1_text')}</p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="attraction-card">
              <img src="/images/prislop.jpg" alt={t('locatie_card2_title')} />
              <div className="card-content">
                <h3>{t('locatie_card2_title')}</h3>
                <p>{t('locatie_card2_text')}</p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="attraction-card">
              <img src="/images/densus.jpg" alt={t('locatie_card3_title')} />
              <div className="card-content">
                <h3>{t('locatie_card3_title')}</h3>
                <p>{t('locatie_card3_text')}</p>
              </div>
            </div>

          </div>
        </div>

        {/* Secțiunea Hartă */}
        <div className="map-panel">
          <h2>{t('locatie_map_title')}</h2>
          <div className="map-wrapper">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d44697.52220478051!2d22.76634355!3d45.56041075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x474e8992a0bdf881%3A0x4009a90de6173a0!2zUsSDY2hpdG92YSAzMzcyNjAsIFJvbWFuaWE!5e0!3m2!1sen!2sro!4v1710000000000!5m2!1sen!2sro" 
              width="100%" 
              height="400" 
              style={{ border: 0, display: 'block' }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Harta Răchitova"
            ></iframe>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Locatie;